import { Vector3 } from '@babylonjs/core/Maths/math.vector';
import remove from 'lodash/remove';

import { SystemLayer } from '../System/systemLayer';
import { UiFollowPoint } from './uiFollowPoint';

export interface HoverPoint {
    point: Vector3,
    text: string,
}

export interface IComment extends HoverPoint {
    id: string,
    author: string,
    date: Date,
}

export interface I3DComment extends IComment {
    followPoint: UiFollowPoint,
}

export class UiHoverPoints {
    protected system: SystemLayer;

    protected container: HTMLElement;

    constructor(
        system: SystemLayer,
        container: HTMLElement,
        hoverPoints: IComment[],
    ) {
        this.system = system;
        this.container = container;
        hoverPoints.forEach((hoverPoint) => {
            this.addPoint(hoverPoint);
        });

        //* For test purpose
        // this.addPoint({ point: Vector3.Zero(), text: 'Hand made leather' });
    }

    private getHtmlFromComment(c: IComment): string {
        return `<div class="naker-hover-author">@${c.author} - ${c.date.toLocaleDateString()}</div><div>${c.text}</div>`
    }

    
    public get comments(): I3DComment[] {
        return this._comments
    }

    private _comments: I3DComment[] = [];

    public addPoint(comment: IComment): I3DComment {
        const followPoint = new UiFollowPoint(this.system, this.container);
        followPoint.show();
        followPoint.keepPointVisible = true;
        let html = this.getHtmlFromComment(comment)
        followPoint.followPoint(comment.point, html);
        const new3DComment = {...comment, followPoint}
        this._comments.push(new3DComment);
        followPoint.point.addEventListener('mouseenter', () => {
            followPoint.showAnim();
        });
        followPoint.point.addEventListener('mouseleave', () => {
            followPoint.shown = false;
            setTimeout(() => {
                //* In case point is hovered again and shown
                if (!followPoint.shown) followPoint.hideAnim();
            }, 1000);
        });
        return new3DComment
    }

    public removePoint(id: string): void {
        const removedPoint: I3DComment = remove(this._comments, (c) => c.id === id)[0];
        if (removedPoint) removedPoint.followPoint.delete();
    }
}
